import React from 'react';
import AmazonLinksSection from '../components/sections/AmazonLinksSection';
import '../styles/pages/ShopPage.css';

const ShopPage = () => {
  return (
    <div className="shop-page-container">
      <h1 className="shop-page-title">Recommended Products</h1>
      <p className="shop-page-intro">
        Here are some products I recommend that can help you with your cookie decorating projects. 
        As an Amazon Associate, I earn from qualifying purchases.
      </p>
      <AmazonLinksSection />
    </div>
  );
};

export default ShopPage;
